import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { SessionDataService } from '../../service/session-data.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-restrict-user-dialog',
  templateUrl: './restrict-user-dialog.component.html',
  styleUrls: ['./restrict-user-dialog.component.css']
,
  standalone: false
})
export class RestrictUserDialogComponent implements OnInit {
  private readonly cfIssuesFeatureName = 'cf issues';
  private readonly hideSitesDropdownFeatureName = 'Hide Sites Dropdown';
  isDisabledViewOnProfileSett:boolean =false;
  isDisabledViewOnArmDisarm: boolean = false;
  isDisabledViewShowPsa: boolean = false;
  featuresList: any = [];
  showTable: boolean;
  userName: any;
  user: any;
  userEmail: any;
  userData: any;
  dialogRefTemplate:MatDialogRef<any>; 
  displayedColumns = ["type", "features","actions"];
  dataSource = new MatTableDataSource([]);
  constructor(public spinner: SpinnerService,public restService: RestService,private toastr: ToastrService,
    private sessionDataService: SessionDataService,
    public dialogRef: MatDialogRef<RestrictUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.userName = this.data?.userName;
  }

  ngOnInit(): void {
    this.getUserName();
  }

  private isCfIssuesFeature(name: string): boolean {
    return (name || '').toLowerCase().trim() === this.cfIssuesFeatureName;
  }

  private isHideSitesDropdownFeature(name: string): boolean {
    return (name || '').toLowerCase().trim() === this.hideSitesDropdownFeatureName.toLowerCase();
  }

  private getFeatureType(feature: any): string {
    return feature?.uiType || feature?.type || feature?.category || (this.isCfIssuesFeature(feature?.name) ? 'Feature' : 'Menu');
  }

  private prepareFeatures(features: any[]): any[] {
    const preparedFeatures = (features || []).map((feature: any) => ({
      ...feature,
      uiType: this.getFeatureType(feature)
    }));

    if (!preparedFeatures.some((feature: any) => this.isCfIssuesFeature(feature?.name))) {
      preparedFeatures.push({
        name: 'CF Issues',
        view: false,
        edit: false,
        uiType: 'Feature'
      });
    }

    return preparedFeatures;
  }

  private getPayloadFeatures(): any[] {
    return this.featuresList.map(({ disabled, uiType, ...feature }) => feature);
  }

  getUserName(){
      this.spinner.activate();
      const url = `${environment.restrictUserDomain}/userfeaturemap/getuserfeatures?username=`;
      this.sessionDataService.restrictUser(url + this.userName).subscribe((response: any) => {
        if (response.status == 200 && response.message == '-') {
          this.spinner.deactivate();
          this.featuresList = this.prepareFeatures(response?.data?.features || []);
          this.dataSource = new MatTableDataSource(this.featuresList);
          this.featuresList.map(itm => {
            if (this.isHideSitesDropdownFeature(itm.name)) {
              itm.edit = false;
              itm.disabled = true;
            }
            if (itm.name == "Weather info" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Dashboard" && itm.edit == false) {
              itm.disabled = true;
            }
            if (itm.name == "Monitoring Hours" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Monitoring Protocols" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Crime Prevention" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Site Activity" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Reports" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Live Views" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Footage" && itm.edit == false) {
              itm.disabled = true;
            } 
            if (itm.name == "Site Summary" && itm.edit == false)
               {
              itm.disabled = true;
            } 
            if (itm.name == "Site Map" && itm.edit == false) {
              itm.disabled = true;
            }
            if (itm.name == "Tips" && itm.edit == false) {
              itm.disabled = true;
            }
            if (itm.name == "Customer Support" && itm.edit == false) {
              itm.disabled = true;
            }
            if (itm.name == "My Sites" && itm.edit == false) {
              itm.disabled = true;
            }
            if (itm.name == "Logout" && itm.edit == false) {
              itm.disabled = true;
            }
            if (itm.name == "Username" && itm.edit == false) {
              itm.disabled = true;
            }
          });
        }
        else{
          this.spinner.deactivate();
          this.toastr.error(response.message, 'Error');
        }
      }, (err) => {
        this.spinner.deactivate(); 
      })
    }

  editCheckBoxEnable(x:any){
    this.featuresList.forEach(itm => {
      switch (x.name) {
        case "Create Planned Site Activity": {
          if (x.name == "Create Planned Site Activity" && itm.name == "Create Planned Site Activity" && !x.edit) {
            itm.edit = true;
            itm.view = true;
          } else if(x.name == "Create Planned Site Activity" && itm.name == "Create Planned Site Activity" && x.edit) {
            itm.edit = false;
            itm.view = false;
          }
          break;
        }

        case "Show Planned Site Activity": {
          if (x.name == "Show Planned Site Activity" && itm.name == "Show Planned Site Activity" && !x.edit) {
            itm.edit = true;
            itm.view = true;
            this.isDisabledViewShowPsa = true;
          } else if(x.name == "Show Planned Site Activity" && itm.name == "Show Planned Site Activity" && x.edit) {
            itm.edit = false;
            itm.view = false;
            this.isDisabledViewShowPsa = false;
          }
          break;
        }

        case "Change Password": {
          if (x.name == "Change Password" && itm.name == "Change Password" && !x.edit) {
            itm.edit = true;
            itm.view = true;
          } else if(x.name == "Change Password" && itm.name == "Change Password" && x.edit) {
            itm.edit = false;
            itm.view = false;
          }
          break;
        }

        case "Profile Settings": {
          if (x.name == "Profile Settings" && itm.name == "Profile Settings" && !x.edit) {
            itm.edit = true;
            itm.view = true;
            this.isDisabledViewOnProfileSett = true;
          } else if(x.name == "Profile Settings" && itm.name == "Profile Settings" && x.edit) {
            itm.edit = false;
            itm.view = false;
            this.isDisabledViewOnProfileSett = false;
          }
          break;
        }

        case "Arm/Disarm toggle": {
          if (x.name == "Arm/Disarm toggle" && itm.name == "Arm/Disarm toggle" && !x.edit) {
            itm.edit = true;
            itm.view = true;
            this.isDisabledViewOnArmDisarm = true;
          } else if(x.name == "Arm/Disarm toggle" && itm.name == "Arm/Disarm toggle" && x.edit) {
            itm.edit = false;
            itm.view = false;
            this.isDisabledViewOnArmDisarm = false;
          }
          break;
        }

        default: {
          if (itm.name == x.name && !x.edit ) {
            itm.edit = true;
            itm.view = true;
          }
          break;
        }
      }
    });
  }

  viewCheckBoxEnable(x){
    this.featuresList.forEach(itm => {
      switch (x.name) {
        case "Create Planned Site Activity": {
          if (x.name == "Create Planned Site Activity" && itm.name == "Create Planned Site Activity" && x.view == false) {
            itm.edit = true;
            itm.view = true;
          } else if(x.name == "Create Planned Site Activity" && itm.name == "Create Planned Site Activity" && x.view == true){
            itm.edit = false;
            itm.view = false;
          }
          break;
        }
        case "Change Password": {
          if (x.name == "Change Password" && itm.name == "Change Password" && x.view == false) {
            itm.edit = true;
            itm.view = true;
          } else if(x.name == "Change Password" && itm.name == "Change Password" && x.view == true) {
            itm.edit = false;
            itm.view = false;
          }
          break;
        }
        case "Show Planned Site Activity": {
         if(x.name == "Show Planned Site Activity" && itm.name == "Show Planned Site Activity" && x.view == true) {
            this.isDisabledViewShowPsa = true;
          } 
          if(x.name == "Show Planned Site Activity" && itm.name == "Show Planned Site Activity" && x.edit == false) {
            this.isDisabledViewShowPsa = false;
          }
          break;
        }
        case "Profile Settings": {
          if(x.name == "Profile Settings" && itm.name == "Profile Settings" && x.view == true) {
             this.isDisabledViewOnProfileSett = true;
           } 
           if(x.name == "Profile Settings" && itm.name == "Profile Settings" && x.edit == false) {
             this.isDisabledViewOnProfileSett = false;
           }
           break;
         }
         case "Arm/Disarm toggle": {
          if(x.name == "Arm/Disarm toggle" && itm.name == "Arm/Disarm toggle" && x.view == true) {
             this.isDisabledViewOnArmDisarm = true;
           } 
           if(x.name == "Arm/Disarm toggle" && itm.name == "Arm/Disarm toggle" && x.edit == false) {
             this.isDisabledViewOnArmDisarm = false;
           }
           break;
         }
      }
    });

  

    if(x.name === 'Show Planned Site Activity' && this.isDisabledViewShowPsa){
      return false;
    } 

    if(x.name ==='Profile Settings' && this.isDisabledViewOnProfileSett){
      return false;
    } 

    if(x.name ==='Arm/Disarm toggle' && this.isDisabledViewOnArmDisarm){
      return false;
    } 
  }

  saveUser() {
    this.spinner.activate();
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.userEmail = this.user.email;
 
    let model = {
      username: this.userName,
      features: this.getPayloadFeatures(),
      modifiedBy: this.userEmail,
    };
    
    let url = `${environment.restrictUserDomain}/userfeaturemap/save`;
    this.sessionDataService.saveRestrictUser(url ,model).subscribe((response: any) => {
      if (response.status == 200) {
        this.toastr.success('Feature Access updated successfully');
        this.dialogRef.close();
        this.spinner.deactivate();
      }
    }, (err) => {
      this.spinner.deactivate();
        this.showTable = false;
        this.toastr.error(err.error.message, 'Error');   
    })

  } 
  closePopUp(){
    this.featuresList = [];
  }
  onClose(): void {
    this.dialogRef.close();
  }

}
